import { LoginPopup } from '~/features/auth'

export const Login = () => <LoginPopup />
